export const removeInvalidValues = (targetObject: object) => {
  // remove properties with null & empty string values
  const updatedObject = Object.fromEntries(
    Object.entries(targetObject).filter(([_, v]) => {
      if (v != null && v != '') {
        return v;
      }
    })
  );

  return updatedObject;
};
